
export function setContentTitle( title : string ) {
	
	let el = document.getElementById( 'content-title' );
	if ( el ) {
		el.textContent = '';
		el.appendChild( document.createTextNode( title ) );
	}

}